import { 
  feed, shop, act
} from '@/api/apiConstants'

const { FEED_INDEX_V2, FEED_SEARCH, FEED_RECOMMEND } = feed;
const { SHOP_INDEX } = shop;
const { FEED_EFO_MORE } = act;

/** 
 * @desc api => 埋点id 绑定关系 [通过eventId获取对应接口里的rec_id]
*/
export const API_EVENT_CONFIG = {
  // 首页接口
  [FEED_INDEX_V2]: [
    'sailing_c_x_homepage_common_sw', // 展示
    'sailing_c_x_homepage_realexposure_sw', // 店铺
    'sailing_c_x_homepage_shop_ck',
    'sailing_c_x_homepage_banner_sw', // banner
    'sailing_c_x_homepage_banner_ck',
    'sailing_c_x_homepage_category_sw', // 品类导航
    'sailing_c_x_homepage_category_ck',
    'sailing_c_x_homepage_filter_sw', // 筛选器
    'sailing_c_x_homepage_filterconfirm_ck',
    'sailing_c_x_homepage_filter_none_sw',
    'sailing_c_x_homepage_filtersort_ck',
    'sailing_c_x_homepage_sorttype_ck',
    'sailing_c_x_search_textbox_ck', // 首页搜索
    'sailing_c_x_search_panel_sw',
    'sailing_c_x_homepage_address_ck', // 首页地址栏
    'sailing_c_x_homepage_top_common_sw', // efo
    'sailing_c_x_homepage_top_more_ck',
  ],
  // 搜索页
  [FEED_SEARCH]: [
    'sailing_c_x_searchresult_common_sw', // 搜索结果页展示
    'sailing_c_x_searchresult_realexposure_sw', // 搜索结果页店铺实曝光
    'sailing_c_x_searchresult_shop_ck', // 搜索结果页店铺点击
  ],
  // 搜索热词
  [FEED_RECOMMEND]: [
    'sailing_c_x_search_hotword_ck', // 热词点击
  ],
  // 商家页
  [SHOP_INDEX] : [
    'sailing_c_x_shop_common_sw', // 展示
    'sailing_c_x_realexposure_sw', // 菜品
    'sailing_c_x_shop_item_ck',
    'sailing_c_x_shop_item_add_ck',
    'sailing_c_x_specselection_common_sw', // 规格选择页面
    'sailing_c_x_specselection_item2cart_ck',
  ],
  // EFO活动页
  [FEED_EFO_MORE] : [
    'sailing_c_x_top_item_realexposure_sw',
    'sailing_c_x_top_item_ck',
    'sailing_c_x_top_buy_ck',
  ]
}
